import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Paper,
  Box,
  Button,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Card,
  Chip,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  TextField,
  Tabs,
  Tab,
  CardContent,
  Divider,
  InputAdornment,
  TableContainer,
  CircularProgress,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AlertDialog from "../../components/Alert/AlertDialog";
import { useDispatch, useSelector } from "react-redux";
import history from "../../utils/HistoryUtils";
import PublishIcon from "@material-ui/icons/Publish";
import axios from "axios";
import apiConfigs from "../../config/config";
import { Pagination } from "@material-ui/lab";
import moment from "moment";
import MessageIcon from "@material-ui/icons/Message";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Notification from "../../components/Notification/Notification";
import "react-datepicker/dist/react-datepicker.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  changeDocStatus,
  deleteSignee,
  downloadChecklistPdf,
  deleteSigneeDoc,
  getSingleSignee,
  getContactEventForSignee,
  signeeCompStatus,
  signeeProStatus,
  getCategories
} from "../../store/action";
import InsertPhotoOutlinedIcon from "@material-ui/icons/InsertPhotoOutlined";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import InfoIcon from "@material-ui/icons/Info";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import CreateContactEvent from "./CreateContactEvent";
import SingleCandidateList from "./SingleCandidateList";
import CreateRemarksEvent from "./CreateRemarksEvent";
import CreateRemarksDocument from "./CreateRemarksDocument";
import CreateDatePickerEvent from "./CreateDatePickerEvent";
import { ADD_SIGNEE_REMARK_SUCCESS } from "../../store/action/actiontypes";
import EnhancedContactEventHead from "./EnhancedContactEventHead";
import { headCellsContactEvent } from "./HeadcellsContactEvent";
import UserNotificationPreference from "../UserNotificationPreference/UserNotificationPreference";
import EditContactEventDialog from "./EditContactDialog";
import { notificationSuccess } from "../../store/action/notificationMsg";
import { deleteCandidateEvent, enabledDisabledLogin, fetCandidateEvent, resetUserLoginUser, saveEvent } from "../../store/action/signee/signeeAction";
import Loading from "../../components/Loading/Loading";
import dayjs from "dayjs";

const getCircleColor = (value) => {
  if (value < 40) return "#e53935"; // red
  if (value < 70) return "#fdd835"; // yellow
  return "#43a047";                 // green
};


const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  heading: {
    color: theme.palette.grey[600],
    fontWeight: 500,
    fontSize: "0.85rem",
    marginBottom: theme.spacing(0.5),
    // textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  desc: {
    color: theme.palette.grey[800],
    fontWeight: 500,
    // marginBottom: theme.spacing(2),
    fontSize: '1rem',
    lineHeight: '1.3',
    margin: 0,
  },
  detailCard: {
    padding: '16px',
    borderRadius: '12px',
    marginBottom: '16px',
    backgroundColor: theme.palette.background.main,
    border: '1px solid #eaeaea',
  },
  detailLabel: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    display: 'block',
    marginBottom: theme.spacing(0.5),
  },
  detailValue: {
    fontWeight: theme.palette.frontWeight.frontWeight500,
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: '6px',
    marginTop: '4px',
  },
  specialtyChip: {
    // backgroundColor: theme.palette.grey['400'],
    // color: theme.palette.primary.main,
  },
  categoryChip: {
    // borderColor: theme.palette.primary.main,
    // color: theme.palette.primary.main,
  },
  remarkBox: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    borderLeft: `3px solid ${theme.palette.primary.light}`,
  },
  statusSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
  progressContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  customProgress: (props) => ({
    "& .MuiCircularProgress-circle": {
      stroke: getCircleColor(props.value),
    },
  }),
  progressCircle: {
    width: 170,
    height: 170,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // margin: '0 auto',
    marginLeft: 'auto',
    // backgroundColor: theme.palette.common.white,
  },
  progressText: {
    fontWeight: 700,
    fontSize: "1.5rem",
  },
  progressLabel: {
    marginTop: theme.spacing(1),
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  statusContainer: {
    width: '100%',
    textAlign: 'center',
  },
  statusLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  statusSelect: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(1),
    },
  },
  selectInput: {
    fontWeight: 500,
  },


  cardHeader: {
    marginBottom: '16px',
    paddingBottom: '12px',
    borderBottom: '1px solid #f0f0f0',
    display: "flex",
    justifyContent: "space-between"
  },
  cardTitle: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontSize: '1.1rem',
    margin: 0,
  },
  gridItem: {
    marginBottom: '4px',
  },
  actionCard: {
    padding: '16px 24px',
    backgroundColor: theme.palette.thead,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.04)',
  },
  detailBox: {
    padding: '8px 12px',
    borderRadius: '8px',
    backgroundColor: '#fafafa',
    minHeight: '64px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      transform: 'translateY(-1px)',
    },
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },

  sectionTitle: {
    fontWeight: 600,
    marginBottom: '16px',
    paddingBottom: '8px',
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
  },
  preferencesGrid: {
    marginBottom: '24px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  preferenceCard: {
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    height: '100%',
    border: "1px solid",
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
  cardContent: {
    padding: '8px !important',
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.background.main,
    alignItems: 'center',
  },
  dayTitle: {
    fontWeight: 600,
    marginBottom: '6px',
    textAlign: 'center',
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  checkbox: {
    padding: '2px',
    '&.Mui-checked': {
      color: theme.palette.listItem,
    },
  },
  checkboxLabel: {
    margin: 0,
    marginBottom: '2px',
    '& .MuiFormControlLabel-label': {
      fontSize: '0.85rem',
    },
  },
  prefCard: {
    borderRadius: '12px',
    height: '100%',
  },
  prefCardContent: {
    padding: '16px !important',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  shiftCount: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    marginRight: '4px',
  },
  travelChip: {
    fontWeight: 600,
    borderRadius: '16px',
    minWidth: '60px',
    justifyContent: 'center',
  },
  prefItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  prefLabel: {
    // flex: 1,
    // marginRight: '12px',
    fontWeight: 500,
    fontSize: '0.85rem',
    color: theme.palette.grey[800],
    width: "240px"
  },
  prefValue: {
    display: 'flex',
    alignItems: 'center',
  },
  dayGridItem: {
    flex: '1 0 auto',
    minWidth: '70px',
    maxWidth: '100px',
    margin: '0 4px',
  },
  sideCard: {
    borderRadius: '8px',
    backgroundColor: theme.palette.background.main,
    color: theme.palette.grey[800],
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  sideCardContent: {
    padding: '8px !important',
    color: theme.palette.grey[800],
  },

  accDetailBackColor: {
    backgroundColor: theme.palette.sidebar,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  docCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: theme.palette.background.main,
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  },
  mainTitle: {
    fontWeight: 500,
    fontSize: "1rem",
    flex: 1,
  },
  fileCon: {
    marginLeft: "auto",
    marginRight: theme.spacing(2),
  },
  uploadFile: {
    position: "absolute",
    left: 0,
    top: 0,
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  statusSelect: {
    minWidth: 160,
  },
  docRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(1.5),
    borderRadius: 6,
    marginBottom: theme.spacing(1),
  },
  docName: {
    minWidth: 250,
    maxWidth: 250,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.9rem",
  },
  remark: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
  },
  tabsection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.grey[300],
    borderRadius: 25,
    padding: 10,
    marginBottom: 10
  },
  tabs: {
    margin: 0,
    padding: 0
  },
  calendarContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  availabilityPanel: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.main,
  },
  buttonGroup: {
    marginTop: theme.spacing(2),
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  availabilityButton: {
    margin: theme.spacing(0.5),
    minWidth: '120px',
  },
  shiftText: {
    color: theme.palette.grey[800],
  }

}));

const DetailSignee = ({ match }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const user_id = match.params.id;
  const [Id, setId] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteDocOpen, setDeleteDocOpen] = useState(false);
  const [docId, setDocsId] = useState(false);
  const [signeeNotify, setSigneeNotify] = useState(false);
  const [docNotify, setDocNotify] = useState(false);
  const [compNotify, setCompNotify] = useState(false);
  const [proNotify, setProNotify] = useState(false);
  const [key1, aetKey1] = useState("");
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const loginDetail = JSON.parse(localStorage.getItem("loginUserInfo"));
  const loginUserInfo = loginDetail;
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [key2, setKey] = useState("");
  const getToken = localStorage.getItem("token")
    ? localStorage.getItem("token").replace(/['"]+/g, "")
    : "";
  const [addDocMsg, setAddDocMsg] = useState("");
  const [fileSizeMsg, setFileSize] = useState("");
  const [notifyMsg, setNotifyMsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = React.useState(1);
  const [searchData, setSearchData] = useState({ search: "" });
  const [open, setOpen] = useState(false);
  const [openRemark, setOpenRemark] = useState(false);
  const [openRemarkDocument, setOpenRemarkDocument] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [remarks, setRemarks] = useState({
    document_subkey: "",
    document_id: "",
  });
  const [remarksDocument, setRemarksDocument] = useState({
    document_subkey: "",
    document_id: "",
    remark: "",
  });
  const [exDateDocument, setDatePicker] = useState({
    document_subkey: "",
    document_id: "",
    expire_date: "",
  });
  const [value, setValue] = React.useState(0);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("created_at");
  const [events, setEvents] = useState([]);
  const [eventDate, setDate] = useState(null);
  const [status, setStatus] = useState(null);
  const { event, savedEvent, saveEventError, deleteLoading, deleteEventError, deleteEvent } = useSelector((state) => state.signee);
  const [info, setInfo] = useState("");

  const handleDateClick = (info) => {
    const date = new Date(info?.date);
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    setDate(formattedDate);
  };
  const handleAddEvent = (name) => {
    setStatus(name);
  }
  const eventData = {
    "user_id": user_id,
  };
  useEffect(() => {
    dispatch(fetCandidateEvent(eventData));
  }, [dispatch, user_id, savedEvent]);

  const toTitleCase = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    if (event && event.length > 0) {
      const formatted = event?.map((event) => ({
        id: event?.id,
        title: toTitleCase(event?.preferense),
        user_id: event?.user_id,
        date: event?.event_date,
        display: 'background',
        color: "black",
        backgroundColor: theme.palette.text[event?.preferense],
      }));
      setEvents(formatted);
    } else {
      setEvents([]);
    }
  }, [event])


  const handleSave = async () => {
    try {
      const date = eventDate != null ? new Date(eventDate) : null;
      const formattedDate = date ? date.toLocaleDateString("en-CA") : null;
      const isEditing = info && info.id;
      const data = {
        ...(isEditing && { id: info.id }),
        user_id: user_id,
        event_date: formattedDate,
        preferense: status,
      };

      const res = await dispatch(saveEvent(data));
      if (res?.data) {
        await dispatch(fetCandidateEvent(res.data));
      }
      setStatus(null);
      setDate(null);

    } catch (error) {
      console.log(error, "error");
    }
  }


  const handleEventClick = async (info) => {
    const event = info.event;
    if (event && event.id) {
      setInfo({ id: event.id });
    }
  }

  const [deleted, setDeleted] = useState(false);
  const handleDelete = async () => {
    const date = eventDate != null ? new Date(eventDate) : null;
    const formattedDate = date ? date.toLocaleDateString("en-CA") : null;
    try {
      const data = {
        user_id: user_id,
        event_date: formattedDate,
      };
      dispatch(deleteCandidateEvent(data))
        .then(async (res) => {
          await dispatch(fetCandidateEvent(eventData));
          setDate(null);
        })
        .catch((error) => {
          console.error("Delete event failed:", error);
          dispatch(deleteEventError(error.response?.data?.message || "Failed to delete event."));
        });
    } catch (error) {
      console.log(error, "error");
      dispatch(deleteEventError(error.message));

    }
  }
  const baseUrl = apiConfigs.API_URL + "uploads/signee_docs/";
  // "http://backendbooking.kanhasoftdev.com/public/uploads/signee_docs/";
  const { profile } = useSelector((state) => state.orgProfile);

  const [visibleColumnsContactEvent, setVisibleColumnsContactEvent] = useState(
    headCellsContactEvent[0].map((col) => col.id) // initially all columns visible
  );

  const {
    getSingleSigneeItem,
    loading,
    deleteSigneeSuccess,
    deleteSigneeError,
    changeDocStatusSuccess,
    signeeProStatusSuccess,
    signeeComStatusSuccess,
    signeeComStatusError,
    deleteDocumentError,
    deleteDocumentSuccess,
    getCandidateEventItem,
    getCandidateEventError,
    addCandidateRemarkSuccess,
    addCandidateRemarkError,
    getCategoriesItem
  } = useSelector((state) => state.signee);

  const [complainceStatus, setComplainceStatus] = useState({
    signee_id: user_id,
    organization_id: "",
    key: "",
    document_status: "",
  });
  const [remarkGeneral, setRemarkGeneral] = useState(null);
  const [remarkDocument, setRemarkDocument] = useState(null);
  const [expireDate, setExpireDate] = useState(null);
  const [editDialog, setEditDialog] = useState(false);
  const [contactData, setContactData] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [profileStatus, setProfileStatus] = useState({
    signee_id: "",
    status: "",
  });
  const [categoryDetail, setCategoryDetail] = useState([]);
  const [complStatus, setComplStatus] = useState({
    signeeId: "",
    status: "",
  });

  const getTotal = () => {
    let completedDocs = 0;

    if (getSingleSigneeItem?.data?.document_list) {
      Object.entries(getSingleSigneeItem?.data?.document_list).map(
        (list, index) => {
          if (list[1]?.data) {

            const tempDocs = Object.entries(list[1]?.data) || {};
            if (!tempDocs?.find((obj) => obj?.[1]?.docs?.length > 0)) {
              return;
            } else {
              for (const [, sectionData] of tempDocs) {
                if (!sectionData.docs.length) {
                  return;
                }
                for (const doc of sectionData.docs) {
                  if (
                    doc.document_status !== "SUCCESS" &&
                    doc.document_status !== "REJECTED" &&
                    doc.is_checked !== 0
                  ) {
                    return;
                  }
                }
              }
              completedDocs += 1;
            }
          }
        }
      );
    }
    return Math.round((completedDocs / 8) * 100);
  };


  const total = getTotal();
  const classes = useStyle({ value: total });

  const deleteStaffItem = (id) => {
    setDeleteOpen(true);
    setId(id);
  };
  const downloadChecklist = (id) => {
    dispatch(downloadChecklistPdf(id));
  };

  const disabledEnabledLogin = (id, status) => {
    let statusData = status === 0 ? "Disabled" : "Enabled"
    let data = { id: id, status: statusData };
    dispatch(enabledDisabledLogin(data));
  }
  const resetUserLogin = (email) => {
    if (!email) {
      console.warn("Email is missing");
      return;
    }
    let data = { email: email };
    dispatch(resetUserLoginUser(data));
  }

  const deleteDocument = (id) => {
    setDeleteDocOpen(true);
    setDocsId(id);
  };
  const [selectedValue, setSelectedValue] = useState("0");

  const [selectedItems, setSelectedItems] = useState([]);

  const handleNewCheckboxChange = async (e, subKey) => {
    const isNewChecked = e.target.value; // Get the current checked state of the checkbox
    const wasPreviouslyNewChecked = selectedItems.includes(subKey); // Check if the item was previously selected

    // Update the checked value
    await updateCheckedNewValue(subKey, isNewChecked);

    // Update the selectedItems state based on the current checked state
    if (isNewChecked && !wasPreviouslyNewChecked) {
      setSelectedItems(prevState => [...prevState, subKey]); // Add the item to selectedItems if it was checked
    } else if (!isChecked && wasPreviouslyNewChecked) {
      setSelectedItems(prevState => prevState.filter(id => id !== subKey)); // Remove the item from selectedItems if it was unchecked
    }
  };

  const updateCheckedNewValue = async (subKey, isChecked) => {
    // const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    let formData = {
      'key': subKey,
      'is_checked': isChecked,
    }
    await axios
      .post(`${apiConfigs.API_URL}api/organization/new-checked/` + user_id, formData, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setLoader(false);
        dispatch(getSingleSignee(user_id));
        dispatch(notificationSuccess(response?.data?.message));
      })
      .catch((error) => {
        console.log("error.message", error.message);
      });
  };
  const handleCheckboxChange = async (e, itemId) => {
    const isChecked = e.target.value; // Get the current checked state of the checkbox
    const wasPreviouslyChecked = selectedItems.includes(itemId); // Check if the item was previously selected

    // Update the checked value
    await updateCheckedValue(itemId, isChecked);

    // Update the selectedItems state based on the current checked state
    if (isChecked && !wasPreviouslyChecked) {
      setSelectedItems(prevState => [...prevState, itemId]); // Add the item to selectedItems if it was checked
    } else if (!isChecked && wasPreviouslyChecked) {
      setSelectedItems(prevState => prevState.filter(id => id !== itemId)); // Remove the item from selectedItems if it was unchecked
    }
  };

  const updateCheckedValue = async (itemId, isChecked) => {
    // const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    let formData = {
      'id': itemId,
      'is_checked': isChecked,
    }
    await axios
      .post(`${apiConfigs.API_URL}api/organization/check-document`, formData, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setLoader(false);
        dispatch(getSingleSignee(user_id));
        dispatch(notificationSuccess(response?.data?.message));
      })
      .catch((error) => {
        console.log("error.message", error.message);
      });
  };

  const alertResponse = (id) => {
    dispatch(deleteSignee(id));
    setSigneeNotify(true);
  };
  const deleteDocResponse = (id) => {
    dispatch(deleteSigneeDoc(id));
    setSigneeNotify(true);
  };

  const deleteRoleClose = () => {
    setDeleteOpen(false);
  };
  const deleteDocClose = () => {
    setDeleteDocOpen(false);
  };

  useEffect(() => {
    dispatch({
      type: ADD_SIGNEE_REMARK_SUCCESS,
      payload: [],
    });
  }, []);

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  useEffect(() => {
    getevent(1, "");
  }, [orderBy, order]);

  useEffect(() => {
    dispatch(getSingleSignee(user_id));
    getevent(1, "");
  }, [user_id]);

  useEffect(() => {
    if (deleteDocumentSuccess?.status === true) {
      dispatch(getSingleSignee(user_id));
      getevent(1, "");
    }
  }, [deleteDocumentSuccess]);

  const backPage = () => {
    history.goBack(-1);
  };
  const upadateLink = () => {
    history.push(`update`);
  };

  const handleComplianceStatus = (event, org_id) => {
    setComplainceStatus({
      ...complainceStatus,
      key: event.target.name,
      document_status: event.target.value,
      organization_id: org_id,
    });
  };

  useEffect(() => {
    if (complainceStatus.key !== "") {
      dispatch(changeDocStatus(complainceStatus));
      setDocNotify(true);
      setTimeout(() => {
        dispatch(getSingleSignee(user_id));
      }, 4000);
    }
  }, [complainceStatus]);

  const handleProfileStatus = (event, id) => {
    setProfileStatus({
      ...profileStatus,
      [event.target.name]: event.target.value,
      signee_id: id,
    });
  };

  // console.log(user_id)
  // console.log(getSingleSigneeItem?.data)

  useEffect(() => {
    if (profileStatus.signee_id !== "") {
      dispatch(signeeProStatus(profileStatus));
      setProNotify(true);
      setTimeout(() => {
        dispatch(getSingleSignee(user_id));
        setProNotify(false);
      }, 4000);
    }
  }, [profileStatus]);

  const handleComplStatus = (event, id) => {
    setComplStatus({
      ...complStatus,
      [event.target.name]: event.target.value,
      signeeId: id,
    });
  };

  useEffect(() => {
    if (complStatus.signeeId !== "") {
      dispatch(signeeCompStatus(complStatus));
      setCompNotify(true);
      setTimeout(() => {
        dispatch(getSingleSignee(user_id));
        setCompNotify(false);
      }, 4000);
    }
  }, [complStatus]);
  let specilaity_list = getSingleSigneeItem?.data?.speciality?.speciality_name
    ? getSingleSigneeItem?.data?.speciality?.speciality_name.split(",")
    : "";

  const handleClick = (e, keyData) => {
    setKey(keyData);
    setSelectedFile(e.target.files);
    setFileSize("");
  };

  useEffect(() => {
    if (selectedFile && selectedFile.length > 0) {
      let totalLength = null;
      if (selectedFile.length <= 5) {
        for (const key of Object.keys(selectedFile)) {
          const fsize = selectedFile.item(key).size;
          const file2 = Math.round(fsize / 1024);
          totalLength += file2;
        }
        if (totalLength <= 20480) {
          onSubmit();
        } else {
          setFileSize("File size should be less than 20MB");
        }
      } else {
        setFileSize("Maximum 5 documents allowed");
      }
    }
  }, [selectedFile]);

  const onSubmit = (e) => {
    let formData = new FormData();
    for (const key of Object.keys(selectedFile)) {
      formData.append("files[]", selectedFile[key]);
      formData.append("key", key2);
    }
    setAddDocMsg("");

    axios
      .post(
        apiConfigs.API_URL + "api/organization/upload-document/" + user_id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          onUploadProgress: (progressEvent) => {
            setLoader(true);
          },
        }
      )
      .then(function (response) {
        const dataItem = response.data;
        if (dataItem && dataItem.status === true) {
          setLoader(false);
          setNotifyMsg(true);
          setAddDocMsg("Document Uploaded Successfully");
          dispatch(getSingleSignee(user_id));
          setSelectedFile([]);
        }
      })
      .catch(function (error) {
        setLoader(false);
        setAddDocMsg(error.message);
      });
  };

  const getevent = (pageNo = 1, search = "") => {
    dispatch(getContactEventForSignee(pageNo, search, user_id, orderBy, order));
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(getevent(page, d1), 100);
    } else {
      setTimeout(getevent(page, ""), 100);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getevent(page, searchData.search), 1000);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getevent(value), 2000);
  };
  const handleClickOpen = (id) => {
    setOpen(true);
  };
  const handleClickOpenRemark = (document_subkey, document_id, data) => {
    setRemarks({ document_subkey: document_subkey, document_id: document_id });
    setOpenRemark(true);
  };
  const handleClickOpenRemarkDocument = (
    document_subkey,
    document_id,
    remark
  ) => {
    setRemarksDocument({
      document_subkey: document_subkey,
      document_id: document_id,
      remark,
    });
    setOpenRemarkDocument(true);
  };

  const handleClickOpenDatePicker = (
    document_subkey,
    document_id,
    expire_date
  ) => {
    setDatePicker({
      document_subkey: document_subkey,
      document_id: document_id,
      expire_date,
    });
    setOpenDatePicker(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseRemarkDocument = () => {
    setOpenRemarkDocument(false);
  };
  const handleCloseRemark = () => {
    setOpenRemark(false);
  };

  const handleCloseDatePicker = () => {
    setOpenDatePicker(false);
  };

  const handleExpireDateChange = (date, id) => {
    const data = {
      expire_date: moment(date).format("YYYY-MM-DD"),
      document_id: id,
    };
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .post(`${apiConfigs.API_URL}api/organization/doc-expiredate`, data, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        const output = response.data;
        if (output?.status === true) {
          setAddDocMsg("Expire date update Successfully");
          dispatch(getSingleSignee(user_id));
        }
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const openEditDialog = (row) => {
    setEditDialog(true);
    // console.log(row)
    setContactData(row);
  };

  useEffect(() => {
    if (getSingleSigneeItem?.data?.remark) {
      setRemarkGeneral(getSingleSigneeItem?.data?.remark);
    }
  }, []);

  const calculateAge = (dob) => {
    if (!dob) return "0"; // return empty string (or 0) if dob is missing

    const birthDate = new Date(dob);
    if (isNaN(birthDate)) return "0"; // invalid date check

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  const tabList = [
    "Details",
    "Preferences",
    "Compliance Document Details",
    "Contact Event list",
    "Booking list",
    "Notification Preference",
  ];



  const getDocUploadedStatus = (docs) => {
    const tempDocs = Object.entries(docs);
    if (!tempDocs?.find((obj) => obj?.[1]?.docs?.filter(d => d.file_name)?.length > 0)) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style={{ marginRight: '18px' }}

        >
          <circle cx="12" cy="12" r="8" fill="red" />
        </svg>
      );
    } else {
      for (const [, sectionData] of tempDocs) {
        if (!sectionData.docs.length) {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ marginRight: '18px' }}
            >
              <circle cx="12" cy="12" r="8" fill="#f57c00" />
            </svg>
          );
        }
        for (const doc of sectionData.docs) {
          if (
            (doc.document_status !== "SUCCESS" &&
              doc.document_status !== "REJECTED") &&
            doc.is_checked !== 0
          ) {
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style={{ marginRight: '18px' }}
              >
                <circle cx="12" cy="12" r="8" fill="#f57c00" />
              </svg>
            );
          }

        }
      }
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          style={{ marginRight: '18px' }}
        >
          <circle cx="12" cy="12" r="11" fill="#22d822" />
          <path
            fill="white"
            d="M9 16.17l-3.5-3.5a1 1 0 0 1 1.41-1.41L9 13.35l6.59-6.59a1 1 0 0 1 1.41 1.41z"
          />
        </svg>
      );

    }
  };

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    let storedCategoryId = getSingleSigneeItem?.data?.categoryItem;
    if (getCategoriesItem.length > 0) {
      const data = Array.isArray(getCategoriesItem)
        ? getCategoriesItem?.filter(item => storedCategoryId?.includes(item.id))
        : [];
      setCategoryDetail(data);
    }
  }, [getCategoriesItem, getSingleSigneeItem?.data?.categoryItem]);

  const availabilityOptions = [
    { key: "longDay", label: "Longday", color: theme.palette.text.longDay },
    { key: "night", label: "Night", color: theme.palette.text.night },
    { key: "earLy", label: "Early", color: theme.palette.text.earLy },
    { key: "late", label: "Late", color: theme.palette.text.late },
    { key: "twiLight", label: "Twilight", color: theme.palette.text.twiLight },
    { key: "notAvailable", label: "Not Available", color: theme.palette.text.notAvailable },
  ];

  return (
    <>

      {(loading || loader) && <Loading open={loading} />}

      {(staffDetail === "Compliance" || staffDetail === "Admin" || loginDetail.role === "ORGANIZATION") && (
        <>
          <Paper className={classes.detailCard} elevation={4}>
            {savedEvent?.message && (
              <Notification data={savedEvent?.message} status="success" />
            )}
            {saveEventError?.message && (
              <Notification data={saveEventError?.message} status="error" />
            )}

            {deleteEventError?.message && (
              <Notification data={deleteEventError?.message} status="error" />
            )}
            {deleteEvent?.message && (
              <Notification data={deleteEvent?.message} status="success" />
            )}

            <Grid container spacing={1} alignItems="center">
              {/* Left section */}
              <Grid item xs={12} sm={8} md={8}>
                <Grid container spacing={2}>
                  {/* Name */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className={classes.userName}>
                      {getSingleSigneeItem?.data?.first_name}{" "}
                      {getSingleSigneeItem?.data?.last_name}
                    </Typography>
                  </Grid>

                  {/* Age */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      style={{
                        color: "white",
                        backgroundColor: "#f57c00",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                    >
                      {calculateAge(getSingleSigneeItem?.data?.date_of_birth)} Years
                    </Typography>
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" style={{ color: theme.palette.listItem }}>
                        Email Address
                      </Typography>
                      <Typography variant="body1" className={classes.detailValue} style={{
                        color: theme.palette.grey[800],
                      }}>
                        {getSingleSigneeItem?.data?.email || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Remark */}
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" style={{ color: theme.palette.listItem }} >
                        Remark
                      </Typography>
                      <Typography variant="body2" className={classes.detailValue} style={{
                        color: theme.palette.grey[800],
                      }}>
                        {getSingleSigneeItem?.data?.remark &&
                          getSingleSigneeItem?.data?.remark !== "undefined"
                          ? getSingleSigneeItem?.data?.remark
                          : "No remarks provided"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Contact Number */}
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" style={{ color: theme.palette.listItem }} >
                        Contact Number
                      </Typography>
                      <Typography variant="body1" className={classes.detailValue} style={{
                        color: theme.palette.grey[800],
                      }}>
                        {getSingleSigneeItem?.data?.contact_number || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Category */}
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" style={{ color: theme.palette.listItem }} >
                        Category
                      </Typography>
                      <Box className={classes.chipContainer}>
                        {categoryDetail.length > 0 ? (
                          categoryDetail.map((value) => (
                            <Chip
                              key={value?.id}
                              label={value?.name}
                              className={classes.categoryChip}
                              color="primary"
                              variant="outlined"
                              size="small"
                              style={{
                                color: theme.palette.grey[800],
                              }}
                            />
                          ))
                        ) : (
                          <Typography variant="body2" color="primary">
                            No categories assigned
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>

                  {/* Consultant */}
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" style={{ color: theme.palette.listItem }} >
                        Consultant
                      </Typography>
                      <Typography variant="body1" className={classes.detailValue} style={{
                        color: theme.palette.grey[800],
                      }}>
                        {getSingleSigneeItem?.data?.consultant || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Speciality */}
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" style={{ color: theme.palette.listItem }} >
                        Speciality
                      </Typography>
                      <Box className={classes.chipContainer}>
                        {specilaity_list.length > 0 ? (
                          specilaity_list.map((list, index) => (
                            <Chip
                              key={index}
                              label={list}
                              className={classes.specialtyChip}
                              size="small"
                              style={{
                                color: theme.palette.text.secondary,
                              }}
                            />
                          ))
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No specialties listed
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right section */}
              <Grid item xs={12} sm={4} md={4}>
                <Box position="relative" display="inline-flex" className={classes.progressCircle}>
                  <CircularProgress
                    variant="determinate"
                    size={150}
                    thickness={6}
                    value={total}
                    color="inherit"
                    className={classes.customProgress}
                  />
                  <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      component="h5"
                      className={classes.progressText}
                      style={{ color: getCircleColor(total) }}
                    >
                      {getTotal()}%
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>

        </>
      )
      }

      {/* Tabs - will take up remaining space */}
      <Box className={classes.tabsection}
        sx={{
          // background: "#e0e0e0",
          // borderRadius: "25px",
          // display: "flex",
          // alignItems: "center",
          // justifyContent: "space-between",
          // px: 1.5, // reduced horizontal padding
          // py: 0.25, // reduced vertical padding
          // mb: 1,
          // height: "fit-content",
        }}
      >
        <Tabs
          value={Math.abs(value)}
          onChange={(e, index) => setValue(index)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          className={classes.tabs}
        >
          {tabList.map((list, index) => (
            <Tab key={index + 888} label={list} />
          ))}
        </Tabs>

        <FormControl
          size="small"
          variant="outlined"
          className={classes.statusSelect}
          sx={{
            width: 200, // reduced width
            alignSelf: "center",
            background: "#fff",
            borderRadius: "20px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "20px",
              height: 36, // keeps select compact
            },
          }}
        >
          <Select
            value={getSingleSigneeItem?.data?.new_status || ""}
            onChange={(e) =>
              handleComplStatus(e, getSingleSigneeItem?.data?.user_id)
            }
            name="status"
            disabled={
              (loginUserInfo?.role === "STAFF" &&
                loginUserInfo?.permissions?.some(
                  (p) => p.toLowerCase() === "candidate-update"
                )) ||
                loginUserInfo?.role !== "STAFF"
                ? false
                : true
            }
            displayEmpty
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Not active">Not active</MenuItem>
            <MenuItem value="Pre reg">Pre reg</MenuItem>
            <MenuItem value="New sign up">New sign up</MenuItem>
            <MenuItem value="Archive">Archive</MenuItem>
            <MenuItem value="Do not use">Do not use</MenuItem>
          </Select>
        </FormControl>
      </Box>


      {
        (signeeNotify || docNotify) && (deleteSigneeSuccess?.message || changeDocStatusSuccess.message) && (
          <Notification data={deleteSigneeSuccess?.message || changeDocStatusSuccess.message} status="success" />
        )
      }
      {
        signeeNotify && deleteSigneeError?.message && (
          <Notification data={deleteSigneeError?.message} status="error" />
        )
      }
      {
        compNotify && signeeComStatusSuccess?.message && (
          <Notification data={signeeComStatusSuccess?.message} status="success" />
        )
      }
      {
        proNotify && signeeProStatusSuccess?.message && (
          <Notification data={signeeProStatusSuccess?.message} status="success" />
        )
      }
      {fileSizeMsg && <Notification data={fileSizeMsg} status="error" />}
      {addDocMsg && <Notification data={addDocMsg} status="success" />}

      {
        deleteDocumentSuccess && deleteDocumentSuccess?.message && (
          <Notification data={deleteDocumentSuccess?.message} status="success" />
        )
      }
      {
        deleteDocumentError && deleteDocumentError?.message && (
          <Notification data={deleteDocumentError?.message} status="error" />
        )
      }
      {
        addCandidateRemarkSuccess && addCandidateRemarkSuccess?.message && (
          <Notification data={addCandidateRemarkSuccess?.message} status="success" />
        )
      }
      {
        addCandidateRemarkError && addCandidateRemarkError?.message && (
          <Notification data={addCandidateRemarkError?.message} status="error" />
        )
      }

      <CreateContactEvent open={open} handleClose={handleClose} signee_id={user_id} />

      <CreateRemarksEvent
        open={openRemark}
        handleClose={handleCloseRemark}
        signee_id={user_id}
        remark={remarks}
        textdata={remarkGeneral ? remarkGeneral : getSingleSigneeItem?.data?.remark}
        setRemarkGeneral={setRemarkGeneral}
      />

      <CreateDatePickerEvent
        open={openDatePicker}
        handleClose={handleCloseDatePicker}
        signee_id={user_id}
        expire_date={exDateDocument}
        setExpireDate={expireDate}
      />
      <CreateRemarksDocument
        open={openRemarkDocument}
        handleClose={handleCloseRemarkDocument}
        signee_id={user_id}
        remark={remarksDocument}
        textdata={remarkDocument ? remarkDocument : ""}
        setRemarkDocument={setRemarkDocument}
      />

      {
        value === 0 && (
          <>
            {/* Personal Details Card */}
            <Paper className={classes.detailCard}>
              <Box className={classes.cardHeader}>
                <Typography variant="h6" className={classes.cardTitle}>
                  Personal Details
                </Typography>
                <Grid item xs={12} sm={6} style={{ flex: "none", marginRight: "9px" }}>
                  {getSingleSigneeItem?.data?.last_login_date ? <Box className={classes.cardTitle}>
                    <Typography variant="h6">Portal last accesed on:{dayjs(getSingleSigneeItem?.data?.last_login_date).format("D MMMM YYYY h:mm a")}</Typography>
                  </Box> : <Box className={classes.cardTitle}>
                    <Typography variant="h6">The user has not logged in yet.</Typography>
                  </Box>}
                </Grid>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>First Name</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.first_name || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Last Name</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.last_name || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Email Address</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.email || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Contact Number</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.contact_number || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Date of birth</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.date_of_birth
                      ? moment(getSingleSigneeItem?.data?.date_of_birth).format("DD-MMM-YYYY").toUpperCase()
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Address</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.address_line_1
                      ? getSingleSigneeItem?.data?.address_line_1
                      : "-"}{" "}
                    {getSingleSigneeItem?.data?.address_line_2}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>City</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.city
                      ? getSingleSigneeItem?.data?.city
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Postcode</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.postcode
                      ? getSingleSigneeItem?.data?.postcode
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Date Registration</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.date_registered
                      ? moment(getSingleSigneeItem?.data?.date_registered).format("DD-MMM-YYYY").toUpperCase()
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Nationality</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.nationality
                      ? getSingleSigneeItem?.data?.nationality
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Registered Body pin</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.nmc_dmc_pin
                      ? getSingleSigneeItem?.data?.nmc_dmc_pin
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Candidate Id</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.candidate_id
                      ? getSingleSigneeItem?.data?.candidate_id
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Revalidation Due Date</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.revalidation_due_date !=
                      "00-00-0000" &&
                      getSingleSigneeItem?.data?.revalidation_due_date != null &&
                      getSingleSigneeItem?.data?.revalidation_due_date != undefined
                      ? moment(getSingleSigneeItem?.data?.revalidation_due_date).format("DD-MMM-YYYY").toUpperCase()
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Appraisal Due Date</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.u_apprisal_due_date !=
                      "00-00-0000" &&
                      getSingleSigneeItem?.data?.u_apprisal_due_date != null &&
                      getSingleSigneeItem?.data?.u_apprisal_due_date != undefined
                      ? moment(getSingleSigneeItem?.data?.u_apprisal_due_date).format("DD-MMM-YYYY").toUpperCase()
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Start Date</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.start_date ? moment(getSingleSigneeItem?.data?.start_date).format("DD-MMM-YYYY").toUpperCase() : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>SOE Registration Date</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.npm_revalidation_date !=
                      "00-00-0000" &&
                      getSingleSigneeItem?.data?.npm_revalidation_date != null &&
                      getSingleSigneeItem?.data?.npm_revalidation_date != undefined
                      ? moment(getSingleSigneeItem?.data?.npm_revalidation_date).format("DD-MMM-YYYY").toUpperCase()
                      : "-"}
                  </Typography>
                </Grid>
                {/* <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Revalidation Due Date</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.revalidation_due_date !=
                      "00-00-0000" &&
                      getSingleSigneeItem?.data?.revalidation_due_date != null &&
                      getSingleSigneeItem?.data?.revalidation_due_date != undefined
                      ? moment(getSingleSigneeItem?.data?.revalidation_due_date).format("DD-MMM-YYYY").toUpperCase()
                      : "-"}
                  </Typography>
                </Grid> */}
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Registration Status</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.registration_status
                      ? getSingleSigneeItem?.data?.registration_status
                      : "-"}
                  </Typography>
                </Grid>

                {(loginDetail.role === "ORGANIZATION" ||
                  staffDetail === "Admin" ||
                  staffDetail === "Compliance" ||
                  loginDetail?.id === getSingleSigneeItem?.data?.created_by ||
                  loginDetail?.id === getSingleSigneeItem?.data?.staff_id) && (
                    <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                      <Typography variant="body2" className={classes.heading}>Consultant</Typography>
                      <Typography variant="h6" className={classes.desc}>
                        {getSingleSigneeItem?.data?.consultant
                          ? getSingleSigneeItem?.data?.consultant
                          : "-"}
                      </Typography>
                    </Grid>
                  )}
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Last shift date</Typography>
                  <Typography variant="h6" className={classes.desc}>
                    {getSingleSigneeItem?.data?.last_shift_date
                      ? moment(getSingleSigneeItem?.data?.last_shift_date).isValid() ? moment(getSingleSigneeItem?.data?.last_shift_date).format('DD-MMM-YYYY').toUpperCase() : "-"
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item xs={12} className={classes.gridItem}>
                  <Typography variant="body2" className={classes.heading}>Speciality:</Typography>
                  <Box className={classes.chipContainer}>
                    {specilaity_list.length > 0
                      ? specilaity_list?.map((list, index) => (
                        <Chip
                          className={classes.specialtyChip}
                          label={list}
                          key={index}
                        />
                      ))
                      : "-"}
                  </Box>
                </Grid>
              </Grid>
            </Paper>

            {/* Payroll Details Card */}
            <Paper className={classes.detailCard}>
              <Box className={classes.cardHeader}>
                <Typography variant="h6" className={classes.cardTitle}>
                  Payroll Details
                </Typography>
              </Box>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Payment Method
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.payment_method
                        ? getSingleSigneeItem?.data?.payment_method
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Umbrella Name
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.name_umbrella
                        ? getSingleSigneeItem?.data?.name_umbrella
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      HRMC Engagement Reason
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.hrmc_engagement_reason
                        ? getSingleSigneeItem?.data?.hrmc_engagement_reason
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Name of Bank
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.name_of_bank
                        ? getSingleSigneeItem?.data?.name_of_bank
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Account Number
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.account_number
                        ? getSingleSigneeItem?.data?.account_number
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Sort Code
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.sort_code
                        ? getSingleSigneeItem?.data?.sort_code
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      NI Number
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.ni_number
                        ? getSingleSigneeItem?.data?.ni_number
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>

            {/* Next of Kin Card */}
            <Paper className={classes.detailCard}>
              <Box className={classes.cardHeader}>
                <Typography variant="h6" className={classes.cardTitle}>
                  Next of Kin
                </Typography>
              </Box>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Name
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.name_of_kin
                        ? getSingleSigneeItem?.data?.name_of_kin
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Address
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.address_of_kin
                        ? getSingleSigneeItem?.data?.address_of_kin
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Contact Number
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.contact_of_kin
                        ? getSingleSigneeItem?.data?.contact_of_kin
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.gridItem}>
                  <Box>
                    <Typography variant="caption" className={classes.heading}>
                      Emergency Contact Number
                    </Typography>
                    <Typography variant="body2" className={classes.desc}>
                      {getSingleSigneeItem?.data?.econtact_of_kin
                        ? getSingleSigneeItem?.data?.econtact_of_kin
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>

            {/* Action Buttons Card */}
            <Box className={classes.actionCard}>
              <Box className={classes.buttonContainer}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={backPage}
                  className={classes.actionButton}
                  size="small"
                >
                  Back
                </Button>

                {((loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-update")) || (loginUserInfo?.role !== "STAFF")) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) =>
                        resetUserLogin(getSingleSigneeItem?.data?.email)
                      }
                    >
                      RESET USER
                    </Button>
                  )}

                {/* candidate-enableLogin */}
                {((loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-update")) || (loginUserInfo?.role !== "STAFF")) && (
                    <Button
                      variant="contained"
                      color={getSingleSigneeItem?.data?.login_status === 0 ? "secondary" : "primary"}
                      onClick={(e) =>
                        disabledEnabledLogin(getSingleSigneeItem?.data?.user_id, getSingleSigneeItem?.data?.login_status)
                      }
                      className={classes.actionButton}
                      size="small"
                    >
                      {getSingleSigneeItem?.data?.login_status === 0 ? 'Disable Login' : "Enable Login"}
                    </Button>
                  )}
                {((loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-update")) || (loginUserInfo?.role !== "STAFF")) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) =>
                        downloadChecklist(getSingleSigneeItem?.data?.user_id)
                      }
                      className={classes.actionButton}
                      size="small"
                    >
                      Download Checklist
                    </Button>
                  )}

                {((loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-update")) || (loginUserInfo?.role !== "STAFF")) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleClickOpenRemark(null, null)}
                      className={classes.actionButton}
                      size="small"
                    >
                      Remarks
                    </Button>
                  )}

                {(loginDetail.role === "ORGANIZATION" ||
                  ((loginUserInfo?.role === "STAFF" &&
                    loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-update")) || (loginUserInfo?.role !== "STAFF")) ||
                  loginDetail?.id === getSingleSigneeItem?.data?.created_by ||
                  loginDetail?.id ===
                  getSingleSigneeItem?.data?.staff_id) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={upadateLink}
                      className={classes.actionButton}
                      size="small"
                    >
                      Edit
                    </Button>
                  )}
                {(((loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-delete")) || (loginUserInfo?.role !== "STAFF")) ||
                  loginUserInfo?.role === "ORGANIZATION") && (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={(e) =>
                        deleteStaffItem(getSingleSigneeItem?.data?.user_id)
                      }
                      className={classes.actionButton}
                      size="small"
                    >
                      Delete
                    </Button>
                  )}
              </Box>
            </Box>
          </>
        )
      }

      {
        value === 1 && (
          <>
            <Typography variant="h5" className={classes.sectionTitle}>
              Availability Preferences
            </Typography>

            {/* Week Days Availability */}
            <Grid container className={classes.preferencesGrid}>
              {/* Days of Week */}
              <Grid item xs={12} md={8}>
                <Grid container justifyContent="space-between" alignItems="stretch">
                  {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => {
                    const dayKey = day.toLowerCase();
                    return (
                      <Grid item xs={4} sm={3} md={1} key={dayKey} className={classes.dayGridItem}>
                        <Card className={classes.preferenceCard} elevation={1}>
                          <CardContent className={classes.cardContent}>
                            <Typography variant="subtitle2" className={classes.dayTitle}>
                              {day}
                            </Typography>
                            <Box className={classes.checkboxGroup}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={getSingleSigneeItem?.data?.preferences?.[`${dayKey}_day`] === 1}
                                    color={theme.palette.listItem}
                                    className={classes.checkbox}
                                    disableRipple
                                  />
                                }
                                label="Day"
                                className={classes.checkboxLabel}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={getSingleSigneeItem?.data?.preferences?.[`${dayKey}_night`] === 1}
                                    color="primary"
                                    className={classes.checkbox}
                                    disableRipple
                                  />
                                }
                                label="Night"
                                className={classes.checkboxLabel}
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>

              {/* Additional Preferences */}
              <Grid item xs={12} md={4}>
                <Grid container spacing={2} direction="column">
                  {/* Shifts per week */}
                  <Grid item>
                    <Card className={classes.sideCard} elevation={1}>
                      <CardContent className={classes.sideCardContent}>
                        <Box className={classes.prefItem}>
                          <Typography variant="body2" className={classes.prefLabel}>
                            Number of shifts per week.:
                          </Typography>
                          <Box className={classes.prefValue}>
                            <Typography variant="body2" className={classes.shiftCount}>
                              {getSingleSigneeItem?.data?.preferences?.no_of_shift || 0}
                            </Typography>
                            <Typography variant="body2" className={classes.shiftText}>
                              Shift{getSingleSigneeItem?.data?.preferences?.no_of_shift !== 1 ? 's' : ''}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Travel preference */}
                  <Grid item>
                    <Card className={classes.sideCard} elevation={1}>
                      <CardContent className={classes.sideCardContent}>
                        <Box className={classes.prefItem}>
                          <Typography variant="body2" className={classes.prefLabel}>
                            Travel for work:
                          </Typography>
                          <Box className={classes.prefValue}>
                            <Chip
                              label={getSingleSigneeItem?.data?.preferences?.is_travel === 1 ? "Yes" : "No"}
                              color={getSingleSigneeItem?.data?.preferences?.is_travel === 1 ? "primary" : "default"}
                              className={classes.travelChip}
                              size="small"
                            />
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={3} className={classes.calendarContainer}>
                {/* Calendar Section */}
                <Grid item xs={12} md={8}>
                  <Card>
                    <CardContent style={{ background: theme.palette.background.main }}>
                      <Typography
                        variant="h5"
                        align="center"
                        gutterBottom
                        color="primary"
                      >
                        Availability Calendar
                      </Typography>
                      <Box style={{ height: '500px' }}>
                        <FullCalendar
                          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                          initialView="dayGridMonth"
                          events={events}
                          selectable={true}
                          dateClick={handleDateClick}
                          eventClick={(info) => handleEventClick(info)}
                          headerToolbar={{
                            // left: "prev,next today",
                            // center: "title",
                            // right: "dayGridMonth,timeGridWeek,timeGridDay",
                          }}
                          height="auto"
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Availability Settings Section */}
                <Grid item xs={12} md={4}>
                  <Paper className={classes.availabilityPanel} elevation={3}>
                    <Typography
                      variant="h6"
                      align="center"
                      gutterBottom
                      color="primary"
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      Set Availability for:
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      align="center"
                      gutterBottom
                      style={{ marginBottom: '20px', fontWeight: 'bold', fontSize: '23px' }}
                    >
                      {eventDate}
                    </Typography>

                    {/* Availability Buttons */}
                    <Box className={classes.buttonGroup}>
                      <Box>
                        {availabilityOptions.reduce((rows, option, index) => {
                          if (index % 2 === 0) rows.push(availabilityOptions.slice(index, index + 2));
                          return rows;
                        }, []).map((row, rowIndex) => (
                          <Box key={rowIndex} className={classes.buttonRow}>
                            {row.map((item) => (
                              <Button
                                key={item.key}
                                variant="outlined"
                                style={{ color: item.color, fontSize: "18px", fontWeight: "600" }}
                                className={classes.availabilityButton}
                                fullWidth
                                onClick={() => handleAddEvent(item.key)}
                              >
                                {item.label}
                              </Button>
                            ))}
                          </Box>
                        ))}
                      </Box>

                      {/* First Row */}
                      {/* <Box className={classes.buttonRow}>
                        <Button
                          onClick={() => handleAddEvent("longDay")}
                          variant="outlined"
                          style={{ color: theme.palette.text.longDay }}
                          className={classes.availabilityButton}
                          fullWidth
                        >
                          Longday
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => handleAddEvent("night")}
                          style={{ color: theme.palette.text.night }}
                          className={classes.availabilityButton}
                          fullWidth
                        >
                          Night
                        </Button>
                      </Box> */}

                      {/* Second Row */}
                      {/* <Box className={classes.buttonRow}>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.earLy }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("earLy")}
                        >
                          Early
                        </Button>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.late }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("late")}
                        >
                          Late
                        </Button>
                      </Box> */}

                      {/* Third Row */}
                      {/* <Box className={classes.buttonRow}>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.twiLight }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("twiLight")}

                        >
                          Twilight
                        </Button>
                        <Button
                          variant="outlined"
                          style={{ color: theme.palette.text.notAvailable }}
                          className={classes.availabilityButton}
                          fullWidth
                          onClick={() => handleAddEvent("notAvailable")}
                        >
                          Not Available
                        </Button>
                      </Box> */}
                    </Box>

                    {/* Action Buttons */}
                    <Box style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                      <Button
                        variant="contained"
                        color={theme.palette.thead}
                        fullWidth
                        onClick={() => handleSave()}
                      >
                        Save Availability
                      </Button>
                      <Button
                        variant="contained"
                        color={theme.palette.grey[800]}
                        fullWidth
                        onClick={() => handleDelete()}
                        disabled={deleteLoading}
                      >
                        Delete Availability
                      </Button>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>

            </Grid>
          </>
        )
      }

      {
        value === 2 && (
          <>
            <Typography variant="h5" className={classes.sectionTitle}>
              Compliance Document Details
            </Typography>

            {getSingleSigneeItem?.data?.document_list &&
              Object.entries(getSingleSigneeItem.data.document_list).map(
                (list, index) => (
                  <Accordion
                    key={index}
                    expanded={expanded === `panel${index + 1}`}
                    onChange={handleChange(`panel${index + 1}`)}
                    style={{ background: theme.palette.thead }}
                  >
                    <AccordionSummary
                      style={{ background: theme.palette.thead }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index + 1}-content`}
                      id={`panel${index + 1}-header`}
                    >
                      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                        {getDocUploadedStatus(list[1]?.data || {})} {list[1].title}
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails className={classes.accDetailBackColor}>
                      <Grid container spacing={2}>
                        {Object.entries(list[1].data || {}).map((lists, idx) => (
                          <Grid item xs={12} key={idx}>
                            <Paper className={classes.docCard}>
                              <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                  <InfoIcon style={{ opacity: 0.6 }} />
                                </Grid>
                                <Grid item xs>
                                  <Typography className={classes.mainTitle}>
                                    {lists[1].subTitle}
                                  </Typography>
                                </Grid>

                                {(staffDetail === "Compliance" ||
                                  staffDetail === "Admin" ||
                                  loginDetail.role === "ORGANIZATION") && (
                                    <>
                                      <div className={classes.fileCon}>
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          size="small"
                                          startIcon={<PublishIcon />}
                                          component="label"
                                        >
                                          Upload
                                          <input
                                            accept="image/*,.pdf"
                                            type="file"
                                            multiple
                                            hidden
                                            onChange={(e) =>
                                              handleClick(e, lists[1].subKey)
                                            }
                                          />
                                        </Button>
                                      </div>
                                      {lists[1]?.docs.filter((d) => d.file_name)
                                        .length > 0 && (
                                          <FormControl
                                            variant="outlined"
                                            size="small"
                                            className={classes.statusSelect}
                                          >
                                            <Select
                                              value={
                                                lists[1].docs[0]?.document_status ||
                                                complainceStatus?.document_status
                                              }
                                              name={lists[0]}
                                              onChange={(e) =>
                                                handleComplianceStatus(
                                                  e,
                                                  getSingleSigneeItem?.data?.parent_id
                                                )
                                              }
                                            >
                                              <MenuItem value="PENDING">PENDING</MenuItem>
                                              <MenuItem value="SUCCESS">ACCEPTED</MenuItem>
                                              <MenuItem value="REJECTED">REJECTED</MenuItem>
                                            </Select>
                                          </FormControl>
                                        )}
                                    </>
                                  )}
                              </Grid>

                              <Divider style={{ margin: "12px 0" }} />

                              {/* Document List */}
                              {lists[1].docs?.length > 0 ? (
                                lists[1].docs.map((items, idx1) => (
                                  <div className={classes.docRow} key={idx1}>
                                    <Box display="flex" alignItems="center" flex={1}>
                                      <Box mr={1}>
                                        {items?.file_name?.endsWith(".pdf") ? (
                                          <PictureAsPdfIcon />
                                        ) : (
                                          <InsertPhotoOutlinedIcon />
                                        )}
                                      </Box>
                                      <a
                                        href={`${baseUrl}/${items?.file_name}`}
                                        target="_blank"
                                        className={classes.docName}
                                      >
                                        {items?.file_name}
                                      </a>
                                    </Box>

                                    <div className={classes.remark}>
                                      <Tooltip title="Remarks" arrow>
                                        <Button
                                          size="small"
                                          color="secondary"
                                          onClick={() =>
                                            handleClickOpenRemarkDocument(
                                              lists[1].subKey,
                                              lists[1].docs[0],
                                              items?.remark || ""
                                            )
                                          }
                                        >
                                          <MessageIcon fontSize="small" />
                                        </Button>
                                      </Tooltip>
                                      : {items?.remark || "—"}
                                    </div>

                                    <div>
                                      {staffDetail === "Compliance" ||
                                        staffDetail === "Admin" ||
                                        loginDetail.role === "ORGANIZATION" ? (
                                        <TextField
                                          value={
                                            items?.expire_date
                                              ? moment(items?.expire_date).format(
                                                "DD-MM-YYYY"
                                              )
                                              : ""
                                          }
                                          placeholder="Set Expiry"
                                          InputProps={{ readOnly: true }}
                                          onClick={() =>
                                            handleClickOpenDatePicker(
                                              lists[1].subKey,
                                              lists[1].docs[idx1],
                                              moment(items?.expire_date).format(
                                                "YYYY-MM-DD"
                                              )
                                            )
                                          }
                                          size="small"
                                        />
                                      ) : (
                                        <Typography variant="body2">
                                          Expire Date:{" "}
                                          {items?.expire_date || "N/A"}
                                        </Typography>
                                      )}
                                    </div>

                                    <DeleteIcon
                                      style={{
                                        marginLeft: 8,
                                        cursor: "pointer",
                                      }}
                                      color="secondary"
                                      onClick={() => deleteDocument(items?.id)}
                                    />

                                    <FormControl
                                      variant="outlined"
                                      size="small"
                                      className={classes.statusSelect}
                                      style={{ marginLeft: 8 }}
                                    >
                                      <Select
                                        value={items?.is_checked}
                                        name="is_checked"
                                        onChange={(e) =>
                                          handleCheckboxChange(e, items?.id)
                                        }
                                      >
                                        <MenuItem value="0">NA</MenuItem>
                                        <MenuItem value="1">Folder Required</MenuItem>
                                        <MenuItem value="2">Compliance Required</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </div>
                                ))
                              ) : (
                                <div className={classes.docRow}>
                                  <Typography color="textSecondary">
                                    Sorry, document doesn’t exist
                                  </Typography>
                                  <FormControl
                                    variant="outlined"
                                    size="small"
                                    className={classes.statusSelect}
                                  >
                                    <Select
                                      name="is_checked"
                                      value={selectedValue}
                                      onChange={(e) =>
                                        handleNewCheckboxChange(e, lists[1].subKey)
                                      }
                                    >
                                      <MenuItem value="0">NA</MenuItem>
                                      <MenuItem value="1">Folder Required</MenuItem>
                                      <MenuItem value="2">Compliance Required</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              )}
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )
              )}
          </>
        )
      }

      {
        value === 3 && (
          <>
            <Paper className={classes.detailCard}>
              <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                <Grid item>
                  <Typography variant="h5" style={{ marginBottom: 16, marginTop: 15 }}>
                    Contact Event list
                  </Typography>
                </Grid>

                <Grid item>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <TextField
                        size="small"
                        placeholder="Search now..."
                        name="search"
                        variant="outlined"
                        onChange={handleSearchChange}
                        onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon
                                style={{
                                  color: "#856f6f", // Icon color
                                  cursor: "pointer",
                                }}
                                onClick={handleClickSearch}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item>
                      <Button color="secondary" variant="contained" onClick={handleClickOpen}>
                        <AddIcon className="mr-2" />
                        Add Contact Event
                      </Button>
                    </Grid>
                  </Grid >
                </Grid >
              </Grid >
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <EnhancedContactEventHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={(event, property) =>
                      handleRequestSort(
                        property,
                        setOrder,
                        setOrderBy,
                        orderBy,
                        order
                      )
                    }
                    rowCount={getCandidateEventItem?.data?.data?.length}
                    headCells={headCellsContactEvent[0]}
                    visibleColumns={visibleColumnsContactEvent}
                  />

                  <TableBody>
                    {getCandidateEventItem?.data?.length > 0 ? (
                      getCandidateEventItem.data.map((row, index) => (
                        <TableRow key={index} hover>
                          <TableCell scope="row" style={{ color: theme.palette.listItem }}>{index + 1}</TableCell>
                          <TableCell style={{ width: "180px" }}>
                            {moment(row.created_at).format("DD MMM YYYY hh:mm A")}
                          </TableCell>
                          <TableCell>{row.comment}</TableCell>
                          <TableCell>{row.first_name}</TableCell>
                          <TableCell>
                            {loginDetail.id === row?.created_by && (
                              <EditIcon onClick={() => openEditDialog(row)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          Sorry, Contact Event not found!
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Pagination */}
              {/* <Box display="flex" justifyContent="flex-end" p={2}>
              <Pagination
                onChange={handleChangePage}
                page={page}
                count={Math.ceil(getCandidateEventItem?.data?.length / 15)}
                showFirstButton
                showLastButton
                color="primary"
              />
            </Box> */}
            </Paper>
          </>
        )
      }

      {value === 4 && <SingleCandidateList user_id={user_id} match={match} />}
      {
        value === 5 && (
          <UserNotificationPreference user_id={user_id} column_name="" type="" />
        )
      }

      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deleteRoleClose}
        response={alertResponse}
        title="Delete Candidate"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />

      <AlertDialog
        id={docId}
        open={deleteDocOpen}
        close={deleteDocClose}
        response={deleteDocResponse}
        title="Delete Candidate Document"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />

      <EditContactEventDialog
        title="edit"
        open={editDialog}
        data={contactData}
        setData={setContactData}
        handleClose={() => setEditDialog(false)}
      />
    </>
  );
};

export default DetailSignee;
